// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZJZm","fullView":"styles_fullView__1o2b_"};